import { useEffect, useState } from 'react'

/** Shared settle time for the people search inputs. */
export const SEARCH_DEBOUNCE_MS = 250

/**
 * Returns `value` once it has stayed unchanged for `delayMs`. Used to keep
 * fast typing from minting a query-cache entry (and a request) per keystroke.
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timeout)
  }, [value, delayMs])

  return debounced
}
